import axios from "axios";
import URLHelper from "../helpers/URLHelper";

const PatientDocumentServices = {
  getTags: async (patient) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/document-tag?patient=${URLHelper.encodeQueryParamValue(patient)}`
    );
    return response;
  },
  getDocuments: async (patient) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/patient-document?patient=${URLHelper.encodeQueryParamValue(patient)}`
    );
    return response;
  },
  uploadDocument: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/patient-document`,
      data,
      {
        timeout: 30000,
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  },
  deleteDocument: async (documentId) => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL +
        `/eira/patient-document?id=${URLHelper.encodeQueryParamValue(documentId)}`
    );
    return response;
  },
};

export default PatientDocumentServices;
